import {
  CREATE_ATTACHMENTS,
  CREATE_CONTRACT,
  DELETE_ATTACHMENTS,
  UPDATE_CONTRACT
} from '../definitions/contract-definitions'
import { BaseDataService } from './base-data.service'

export class ContractDataService {
  constructor(private baseDataService: BaseDataService) {}

  createContract(input) {
    return this.baseDataService.mutate(CREATE_CONTRACT, {
      input
    })
  }

  updateContract(input) {
    return this.baseDataService.mutate(UPDATE_CONTRACT, {
      input
    })
  }

  createAttachments(files: File[], tags: string[], customFields?: JSON) {
    return this.baseDataService.mutate(CREATE_ATTACHMENTS, {
      input: files.map((file) => ({ file, tags, customFields }))
    })
  }

  deleteAvatars(ids: string[], force: boolean) {
    return this.baseDataService.mutate(DELETE_ATTACHMENTS, {
      input: {
        assetIds: ids,
        force
      }
    })
  }
}
